import React from "react";
import { Container, Row } from "shards-react";

import PageTitle from "../components/common/PageTitle";
import FormSignUp from "../components/forms/FormSignUp";

const SignUp = () => (
  <Container
    fluid
    className="main-content-container px-4 pb-4"
    style={{ maxWidth: "800px" }}
  >
    {/* Page Header */}
    <Row noGutters className="page-header py-4">
      <PageTitle
        sm="4"
        title="Registrarse"
        subtitle=""
        className="text-sm-left"
      />
    </Row>
    <FormSignUp />
  </Container>
);

export default SignUp;
